
import Vue from "vue";
import VButton from "@/components/common/button.vue";
import MaterialIcon from "@/components/common/material-icons.vue";
import { mapGetters } from "vuex";
import { isBelowIOS14 } from "@/util/mobile";

export default Vue.extend({
  name: "not-ready-alert-view",
  components: { VButton, MaterialIcon },
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
  },
  computed: {
    ...mapGetters("data", ["getLanguageWithoutCountry"]),
    btnAction(): string {
      return this.$i18n.t("Alert.notReadyButtonTitle") as string;
    },
    showIcon(): string {
      return this.getLanguageWithoutCountry === "en"
        ? require("@/assets/images/map-markers/notReady-en.svg")
        : require("@/assets/images/map-markers/notReady.svg");
    },
    showTitle(): string {
      return this.subtitle === "" ? (this.$i18n.t("Alert.notReadyTitle") as string) : this.subtitle;
    },
    showSubtitle(): string {
      return this.subtitle === "" ? (this.$i18n.t("Alert.notReadySubTitle") as string) : this.subtitle;
    },
    /* @remarks the change is only for QA-220113 **/
    // TODO: change layout-ios-dummy for all components next time
    isBelowIOS14() {
      return isBelowIOS14();
    },
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
  },
});
